interface ArticleGalleryProps {
  images: string[];
}

export const ArticleGallery = ({ images }: ArticleGalleryProps) => {
  return (
    <div className="flex my-6 w-fit overflow-hidden space-x-4">
      {images.map((url, index) => {
        return (
          <div className="items-center flex rounded-lg" key={index}>
            <img src={url} alt="" className="w-full h-auto p-4 border-2" />
          </div>
        );
      })}
    </div>
  );
};
